<template>
  <div class="magnetic-flux-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Φ = B · A_effective | ε = -ΔΦ/Δt$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Background Magnetic Field (B) -->
          <g>
            <line v-for="y in 5" :key="'b'+y" x1="20" :y1="40 + y*30" x2="380" :y2="40 + y*30" stroke="rgba(0, 210, 255, 0.2)" stroke-width="2" marker-end="url(#b-arrow)" />
          </g>

          <!-- The Rotating Loop -->
          <g :transform="`translate(200, 120) rotate(${angle})`">
             <!-- Surface transparency depends on effective area -->
             <rect x="-40" y="-60" width="80" height="120" :fill="`rgba(255, 215, 0, ${0.1 + Math.abs(Math.cos(angleRad))*0.3})`" stroke="#ffd700" stroke-width="2" />
             <!-- Normal Vector -->
             <line x1="0" y1="0" x2="60" y2="0" stroke="#ff4757" stroke-width="2" marker-end="url(#n-arrow)" />
             <text x="65" y="5" fill="#ff4757" font-size="10">n̂ (法线)</text>
          </g>

          <defs>
            <marker id="b-arrow" markerWidth="8" markerHeight="6" refX="0" refY="3" orient="auto">
              <polygon points="0 0, 8 3, 0 6" fill="rgba(0, 210, 255, 0.5)" />
            </marker>
            <marker id="n-arrow" markerWidth="8" markerHeight="6" refX="0" refY="3" orient="auto">
              <polygon points="0 0, 8 3, 0 6" fill="#ff4757" />
            </marker>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>夹角 θ: {{ angle }}°</label>
              <div class="value">有效穿过面积 A' = A cosθ</div>
           </div>
           <div class="flux-meter">
              <div class="label">当前磁通量 Φ</div>
              <div class="bar-container">
                 <div class="bar" :style="{ width: Math.abs(Math.cos(angleRad))*100 + '%', background: '#00d2ff' }"></div>
              </div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>手动旋转角度 θ</label>
             <el-slider v-model="angle" :min="0" :max="180" size="mini"></el-slider>
          </div>
          <div class="row button-group">
             <el-button size="mini" type="primary" @click="autoRotate = !autoRotate">
               {{ autoRotate ? '停止旋转' : '自动旋转 (产生交变电流)' }}
             </el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>磁通量 Φ 表示穿过某一面积的磁感线条数。当线圈与磁场<strong>垂直</strong>时，磁通量最大；当线圈与磁场<strong>平行</strong>时，磁通量为零。磁通量的<strong>变化率</strong>决定了感应电动势的大小。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MagneticFluxViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      angle: 0,
      autoRotate: false,
      running: true
    }
  },
  computed: {
    angleRad() { return (this.angle * Math.PI) / 180; }
  },
  methods: {
    update() {
      if (this.running && this.autoRotate) {
        this.angle = (this.angle + 2) % 360;
      }
      requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { this.running = false; }
}
</script>

<style scoped lang="scss">
.magnetic-flux-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.hud-top { 
  position: absolute; top: 15px; left: 15px; width: 140px;
  .stat label { font-size: 0.65rem; color: #888; }
  .flux-meter { 
    margin-top: 10px; 
    .label { font-size: 0.6rem; color: #00d2ff; margin-bottom: 4px; }
    .bar-container { width: 100%; height: 4px; background: rgba(255,255,255,0.1); border-radius: 2px; }
    .bar { height: 100%; border-radius: 2px; transition: width 0.1s linear; box-shadow: 0 0 10px rgba(0, 210, 255, 0.5); }
  }
}
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } 
  .button-group { margin-top: 10px; }
}
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
